import { loadStripe } from '@stripe/stripe-js/pure';
import urlJoin from 'proper-url-join';

import BaseService from './base.service';

export default class PaymentService extends BaseService {
  stripe;

  async initStripe() {
    if (!this.stripe) {
      this.stripe = await loadStripe(process.env.REACT_APP_STRIPE_PUBLISH_KEY, {
        apiVersion: '2020-08-27',
      });
    }
  }

  async createCaseCheckoutSession(studyId, currentRoute = null, type = 'Standard', caseId = null, patientId = null, successRoute = null) {
    const query = studyId ? `?studyId=${studyId}` : '';

    return this.get(
      urlJoin('/payment/create-case-checkout-session', {
        query: {
          cancelRoute: currentRoute ?? process.env.REACT_APP_STRIPE_CANCEL_ROUTE,
          caseId: caseId || undefined,
          patientId: patientId || undefined,
          successRoute: `${successRoute || process.env.REACT_APP_STRIPE_CASE_SUCCESS_ROUTE}${query}`,
          type,
        },
      })
    );
  }

  async createPackageCheckoutSession(plan, currentRoute = null) {
    return this.get(
      urlJoin('/payment/create-package-checkout-session', {
        query: {
          cancelRoute: currentRoute ?? process.env.REACT_APP_STRIPE_CANCEL_ROUTE,
          plan,
          successRoute: process.env.REACT_APP_STRIPE_PACKAGE_SUCCESS_ROUTE,
        },
      })
    );
  }

  async createSubscriptionCheckoutSession(plan, currentRoute = null) {
    return this.get(
      urlJoin('/payment/create-subscription-checkout-session', {
        query: {
          cancelRoute: currentRoute ?? process.env.REACT_APP_STRIPE_CANCEL_ROUTE,
          plan,
          successRoute: process.env.REACT_APP_STRIPE_SUBSCRIPTION_SUCCESS_ROUTE,
        },
      })
    );
  }

  async isValidSession(sessionId) {
    return this.get(`/payment/session/${sessionId}/is-valid-session`);
  }

  async redirectToCheckout(sessionId) {
    await this.initStripe();
    return this.stripe.redirectToCheckout({ sessionId });
  }

  cancelPlan() {
    return this.get('/payment/cancel-subscription');
  }
}
